import React, { useContext } from 'react';
import {
    ICreateSavedFilter,
    ISavedFilter,
    SavedFilterStatus,
    SavedFilterSubType,
    SavedFilterType,
} from '../../../../components/sidebar-filters/saved-filter/interface';
import { SidebarFilterActions } from '../../../../components/sidebar-filters/SidebarFilterActions';
import { ENERGY_USAGE_PAGE_CONST } from '../constants';
import { EnergyUsageSidebarFiltersContext, IEnergyUsageSidebarFiltersContext } from '../context/EnergyUsageSidebarFiltersContext';
import { EnergyUsageSidebarFilterTabs } from '../sites-filtering/EnergyUsageSidebarFilterTabs';

interface IFiltersPanelProps {
    siteFiltersCollapsed: boolean;
    onOpenSaveFiltersModal: (createSavedFilter: ICreateSavedFilter) => void;
}

export const EnergyUsageFiltersPanel: React.FC<IFiltersPanelProps> = ({ siteFiltersCollapsed, onOpenSaveFiltersModal }) => {
    const { handleSiteFiltersClear, siteFiltersCount, siteFilters } = useContext<IEnergyUsageSidebarFiltersContext>(EnergyUsageSidebarFiltersContext);

    const handleOpenSaveFiltersModal = (filter?: ISavedFilter) => {
        const initialFilter = {
            id: filter?.id || null,
            description: filter?.description || '',
            status: filter?.status || SavedFilterStatus.active,
            type: filter?.type || SavedFilterType.filter,
            filter_name: filter?.filter_name || '',
            display_in_dashboard: filter?.display_in_dashboard || false,

            filter_values: filter?.filter_values || siteFilters,
            sub_type: SavedFilterSubType.energyUsageDataAnalytics,
        };

        onOpenSaveFiltersModal(initialFilter);
    };

    if (siteFiltersCollapsed) {
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: `${ENERGY_USAGE_PAGE_CONST.filtersCollapsedWidth}px`,
                    height: '100%',
                    backgroundColor: 'var(--ant-color-primary)',
                }}
            />
        );
    }

    return (
        <div style={{ borderRight: `1px solid #d9d9d9` }}>
            <EnergyUsageSidebarFilterTabs onOpenSaveFiltersModal={handleOpenSaveFiltersModal} />
            <SidebarFilterActions
                shownActions={['saveFilters', 'clearFilters']}
                isSaveDisabled={siteFiltersCount === 0}
                onSaveFilters={handleOpenSaveFiltersModal}
                onClearFilters={handleSiteFiltersClear}
            />
        </div>
    );
};
